import { Component, OnInit, OnDestroy } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { ThemeService } from '../../services/theme.service';
import { Subscription } from 'rxjs';

@Component({
  selector: 'app-blank-layout',
  standalone: true,
  imports: [RouterOutlet],
  template: `
    <div class="blank-layout">
      <router-outlet></router-outlet>
    </div>
  `,
  styles: [
    `
      .blank-layout {
        height: 100vh;
        width: 100vw;
        overflow: auto;
        background-color: #fafafa;
        display: flex;
        flex-direction: column;
        transition: background-color 0.3s ease;
      }

      /* Center content for auth pages */
      :host {
        height: 100vh;
        width: 100vw;
      }

      /* Optional: Add some basic styling for auth pages */
      ::ng-deep .auth-container {
        height: 100vh;
        display: flex;
        align-items: center;
        justify-content: center;
        background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
        transition: background 0.3s ease;
      }

      ::ng-deep .auth-card {
        width: 100%;
        max-width: 400px;
        margin: 20px;
        box-shadow: 0 8px 32px rgba(0, 0, 0, 0.1);
        border-radius: 12px;
        transition: box-shadow 0.3s ease;
      }

      @media (max-width: 480px) {
        ::ng-deep .auth-card {
          margin: 10px;
          max-width: none;
        }
      }
    `,
  ],
})
export class BlankLayoutComponent implements OnInit, OnDestroy {
  private themeSubscription?: Subscription;

  constructor(private themeService: ThemeService) {}

  ngOnInit(): void {
    // Forzar la aplicación del tema al cargar el blank layout
    // Esto asegura que el tema se aplique incluso si el servicio se inicializó antes
    const currentTheme = this.themeService.currentTheme();
    this.themeService.setTheme(currentTheme);
  }

  ngOnDestroy(): void {
    this.themeSubscription?.unsubscribe();
  }
}
